export interface PhonemeEntry {
  phoneme: string;
  filename: string;
  videoFilename?: string;
}

// audio and video filename are the same
//   - audio path is <amiraAssetDomain>/phonemes
//   - video path is <amiraAssetDomain>/phonemes/videos
export const phonemeLookup: PhonemeEntry[] = [
  { phoneme: 'ɒ', filename: 'aa', videoFilename: 'aa' },
  { phoneme: 'æ', filename: 'ae', videoFilename: 'ae' },
  { phoneme: 'ʌ', filename: 'ah', videoFilename: 'ah' },
  { phoneme: 'ɔ', filename: 'ao', videoFilename: 'ao' },
  { phoneme: 'aʊ', filename: 'aw', videoFilename: 'aw' },
  { phoneme: 'aɪ', filename: 'ay', videoFilename: 'ay' },
  { phoneme: 'æ̃', filename: 'ai' },
  { phoneme: 'b', filename: 'b', videoFilename: 'b' },
  { phoneme: 'ʧ', filename: 'ch', videoFilename: 'ch' },
  { phoneme: 'd', filename: 'd', videoFilename: 'd' },
  { phoneme: 'ð', filename: 'dh', videoFilename: 'dh' },
  { phoneme: 'ɛ', filename: 'eh', videoFilename: 'eh' },
  { phoneme: 'ɝ', filename: 'er', videoFilename: 'er' },
  { phoneme: 'ɚ', filename: 'er', videoFilename: 'er' },
  { phoneme: 'eɪ', filename: 'ey', videoFilename: 'ey' },
  { phoneme: 'f', filename: 'f', videoFilename: 'f' },
  { phoneme: 'ɡ', filename: 'g', videoFilename: 'g' },
  { phoneme: 'g', filename: 'g', videoFilename: 'g' },
  { phoneme: 'h', filename: 'h', videoFilename: 'h' },
  { phoneme: 'ɪ', filename: 'ih', videoFilename: 'ih' },
  { phoneme: 'I', filename: 'ih', videoFilename: 'ih' },
  { phoneme: 'i', filename: 'iy', videoFilename: 'iy' },
  { phoneme: 'ʤ', filename: 'jh', videoFilename: 'jh' },
  { phoneme: 'ju', filename: 'ju', videoFilename: 'ju' },
  { phoneme: 'k', filename: 'k', videoFilename: 'k' },
  { phoneme: 'l', filename: 'l', videoFilename: 'l' },
  { phoneme: 'm', filename: 'm', videoFilename: 'm' },
  { phoneme: 'n', filename: 'n', videoFilename: 'n' },
  { phoneme: 'ŋ', filename: 'ng', videoFilename: 'ng' },
  { phoneme: 'oʊ', filename: 'ow', videoFilename: 'ow' },
  { phoneme: 'ɔɪ', filename: 'oy', videoFilename: 'oy' },
  { phoneme: 'p', filename: 'p', videoFilename: 'p' },
  { phoneme: 'r', filename: 'r', videoFilename: 'r' },
  { phoneme: 'ɹ', filename: 'r', videoFilename: 'r' },
  { phoneme: 'ɑ', filename: 'aar', videoFilename: 'aar' },
  { phoneme: 'ə', filename: 'au', videoFilename: 'au' },
  { phoneme: 'ɪɹ', filename: 'iyr', videoFilename: 'iyr' },
  { phoneme: 'ɛɹ', filename: 'ehr', videoFilename: 'ehr' },
  { phoneme: 'ʊɹ', filename: 'ure', videoFilename: 'ure' },
  { phoneme: 's', filename: 's', videoFilename: 's' },
  { phoneme: 'ʃ', filename: 'sh', videoFilename: 'sh' },
  { phoneme: 't', filename: 't', videoFilename: 't' },
  { phoneme: 'θ', filename: 'th', videoFilename: 'th' },
  { phoneme: 'ʊ', filename: 'uh', videoFilename: 'uh' },
  { phoneme: 'u', filename: 'uw', videoFilename: 'uw' },
  { phoneme: 'v', filename: 'v', videoFilename: 'v' },
  { phoneme: 'w', filename: 'w', videoFilename: 'w' },
  { phoneme: 'j', filename: 'y', videoFilename: 'y' },
  { phoneme: 'z', filename: 'z', videoFilename: 'z' },
  { phoneme: 'ʒ', filename: 'zh', videoFilename: 'zh' },
  { phoneme: 'kw', filename: 'kw', videoFilename: 'kw' },
  { phoneme: 'ks', filename: 'ks', videoFilename: 'ks' },
  { phoneme: 'ɑɹ', filename: 'ar', videoFilename: 'ar' },
  { phoneme: 'ɔɹ', filename: 'or', videoFilename: 'or' },
  { phoneme: 'jɝ', filename: 'yuh' },
  { phoneme: 'dd', filename: 'dd' },
  { phoneme: 'əl', filename: 'll', videoFilename: 'll' },
];

//   - word parts path is <amiraAssetDomain>/phonemes/word-parts
//   - word parts video path is <amiraAssetDomain>/phonemes/word-parts/videos
export const wordPartsLookup: PhonemeEntry[] = [
  { phoneme: 'augh', filename: 'augh', videoFilename: 'augh' },
  { phoneme: 'wor', filename: 'wor', videoFilename: 'wor' },
  { phoneme: 'ouwh', filename: 'ouwh', videoFilename: 'ouwh' },
  { phoneme: 'ough', filename: 'ough', videoFilename: 'ough' },
  { phoneme: 'ouph', filename: 'ouph', videoFilename: 'ouph' },
  { phoneme: 'ouaa', filename: 'ouaa', videoFilename: 'ouaa' },
  { phoneme: 'ouff', filename: 'ouff', videoFilename: 'ouff' },
  { phoneme: 'ouuw', filename: 'ouuw', videoFilename: 'ouuw' },
  { phoneme: 'gu', filename: 'gu', videoFilename: 'gu' },
  { phoneme: 'al', filename: 'al', videoFilename: 'al' },
  { phoneme: 'ed', filename: 'ed' },
  { phoneme: 'es', filename: 'es' },
  { phoneme: 'est', filename: 'est' },
  { phoneme: 'ing', filename: 'ing' },
  { phoneme: 'en', filename: 'en' },
  { phoneme: 'in', filename: 'in' },
  { phoneme: 'pre', filename: 'pre' },
  { phoneme: 're', filename: 're' },
  { phoneme: 'un', filename: 'un' },
  { phoneme: 'ied', filename: 'ied' },
  { phoneme: 'ier', filename: 'ier' },
  { phoneme: 'ees', filename: 'ees' },
  { phoneme: 'ies', filename: 'ies' },
  { phoneme: 'iest', filename: 'iest' },
  { phoneme: 'dis', filename: 'dis' },
  { phoneme: 'ex', filename: 'ex' },
  { phoneme: 'mis', filename: 'mis' },
  { phoneme: 'non', filename: 'non' },
  { phoneme: 'ful', filename: 'ful' },
  { phoneme: 'less', filename: 'less' },
  { phoneme: 'ly', filename: 'ly' },
  { phoneme: 'ness', filename: 'ness' },
  { phoneme: 'over', filename: 'over' },
  { phoneme: 'post', filename: 'post' },
  { phoneme: 'pro', filename: 'pro' },
  { phoneme: 'pruh', filename: 'pruh' },
  { phoneme: 'hood', filename: 'hood' },
  { phoneme: 'ment', filename: 'ment' },
  { phoneme: 'anti', filename: 'anti' },
  { phoneme: 'fore', filename: 'fore' },
  { phoneme: 'mid', filename: 'mid' },
  { phoneme: 'semi', filename: 'semi' },
  { phoneme: 'sub', filename: 'sub' },
  { phoneme: 'super', filename: 'super' },
  { phoneme: 'age', filename: 'age' },
  { phoneme: 'ayn', filename: 'ayn' },
  { phoneme: 'ain', filename: 'ain' },
  { phoneme: 'ice', filename: 'ice' },
  { phoneme: 'ive', filename: 'ive' },
  { phoneme: 'shion', filename: 'shion' },
  { phoneme: 'di', filename: 'di' },
  { phoneme: 'vi', filename: 'vi' },
  { phoneme: 'zhion', filename: 'zhion' },
  { phoneme: 'zhure', filename: 'zhure' },
  { phoneme: 'trea', filename: 'trea' },
  { phoneme: 'ture', filename: 'ture' },
  { phoneme: 'pic', filename: 'pic' },
  { phoneme: 'inter', filename: 'inter' },
  { phoneme: 'trans', filename: 'trans' },
];

//   - spanish phoneme path is <amiraAssetDomain>/phonemes/spanish
export const spanishPhonemeLookup: PhonemeEntry[] = [
  { phoneme: 'a', filename: 'spanish/A' },
  { phoneme: 'b', filename: 'spanish/B' },
  { phoneme: 'β', filename: 'spanish/BV' },
  { phoneme: 'tʃ', filename: 'spanish/CH' },
  { phoneme: 'd', filename: 'spanish/D' },
  { phoneme: 'ð', filename: 'spanish/DH' },
  { phoneme: 'ɾ', filename: 'spanish/DX' },
  { phoneme: 'e', filename: 'spanish/E' },
  { phoneme: 'f', filename: 'spanish/F' },
  { phoneme: 'ɡ', filename: 'spanish/G' },
  { phoneme: 'ɣ', filename: 'spanish/GH' },
  { phoneme: 'h', filename: 'spanish/H' },
  { phoneme: 'i', filename: 'spanish/I' },
  { phoneme: 'ʝ', filename: 'spanish/J' },
  { phoneme: 'ɟʝ', filename: 'spanish/JJ' },
  { phoneme: 'k', filename: 'spanish/K' },
  { phoneme: 'l', filename: 'spanish/L' },
  { phoneme: 'm', filename: 'spanish/M' },
  { phoneme: 'ɱ', filename: 'spanish/MM' },
  { phoneme: 'n', filename: 'spanish/N' },
  { phoneme: 'ŋ', filename: 'spanish/NG' },
  { phoneme: 'ɲ', filename: 'spanish/NN' },
  { phoneme: 'o', filename: 'spanish/O' },
  { phoneme: 'p', filename: 'spanish/P' },
  { phoneme: 'r', filename: 'spanish/RR' },
  { phoneme: 's', filename: 'spanish/S' },
  { phoneme: 't', filename: 'spanish/T' },
  { phoneme: 'θ', filename: 'spanish/TH' },
  { phoneme: 'u', filename: 'spanish/U' },
  { phoneme: 'v', filename: 'spanish/V' },
  { phoneme: 'w', filename: 'spanish/W' },
  { phoneme: 'x', filename: 'spanish/X' },
  { phoneme: 'j', filename: 'spanish/Y' },
  { phoneme: 'ʎ', filename: 'spanish/YY' },
  { phoneme: 'z', filename: 'spanish/Z' },
];

export const CLIENT_WORD_METADATA_DB: {
  WORDPART: { [key: string]: PhonemeEntry };
  PHO: { [key: string]: PhonemeEntry };
} = {
  WORDPART: {
    // 'key' is the phoneme and the value is the PhonemeEntry of wordPartsLookup
    ...wordPartsLookup.reduce(
      (acc, entry) => {
        acc[entry.phoneme] = entry;
        return acc;
      },
      {} as Record<string, PhonemeEntry>
    ),
  },
  PHO: {
    // 'key' is the phoneme and the value is the PhonemeEntry of phonemeLookup
    ...phonemeLookup.reduce(
      (acc, entry) => {
        acc[entry.phoneme] = entry;
        return acc;
      },
      {} as Record<string, PhonemeEntry>
    ),
  },
};
